<template>
  <v-footer color="primary" class="px-4">
    <v-container>
      <v-row align="center" justify="space-between">
        <v-col cols="12" md="6" class="text-center text-md-left">
          <span class="text-body-2">
            © {{ currentYear }} BANJINO'S, LLC | ADMIN PORTAL
          </span>
        </v-col>
        
        <v-col cols="12" md="6" class="text-center text-md-right">
          <v-btn
            v-for="link in footerLinks"
            :key="link.title"
            :to="link.to"
            text
            small
            class="mx-1"
          >
            {{ link.title }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      footerLinks: [
        {
          title: 'Terms of Service',
          to: '/terms-of-service'
        },
        {
          title: 'Privacy Policy',
          to: '/privacy-policy'
        },
        {
          title: 'User Data Deletion',
          to: '/user-data-deletion'
        }
      ]
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.v-footer {
  z-index: 5;
}
</style>